// extracted by mini-css-extract-plugin
export default {"messageContainer":"Notifications_messageContainer__qxLiI"};